// src/components/tokenPage/derivatives/RegimeCard.tsx

import React, { useState } from "react";
import TimeRangePicker, { type TimeRangeOption } from "@/components/common/TimeRangePicker";
import { MetricBox } from "../shared/TokenDashboardComponents";
import { useTokenDerivatives } from "@/contexts/token";
import { DataCard } from "@/components/ui";

interface Props {
  ticker: string;
}

type WindowKey = '7d' | '30d' | '180d' | '365d';

const RegimeCard: React.FC<Props> = () => {
  const regimeRangeOptions: readonly TimeRangeOption[] = ['7d','30d','180d','365d'];
  const [regimeRange, setRegimeRange] = useState<TimeRangeOption>('7d');
  
  const { regime, fundingOiWeighted, fundingVolWeighted, isLoading } = useTokenDerivatives();
  
  // Get pre-computed stats for selected window
  const windowKey = regimeRange as WindowKey;
  const pOiw = fundingOiWeighted.stats[windowKey].percentPositive;
  const pVolw = fundingVolWeighted.stats[windowKey].percentPositive;

  // Hide if no data available (after loading)
  const hasData = regime !== 'Mixed' || pOiw != null || pVolw != null;
  if (!isLoading && !hasData) {
    return null;
  }

  return (
    <DataCard
      title="Regime"
      isLoading={isLoading}
      loadingVariant="stats"
      actions={
        <TimeRangePicker options={regimeRangeOptions} value={regimeRange} onChange={setRegimeRange} theme="blue" />
      }
    >
      <div className="flex items-center gap-2 mb-3">
        <span className={`px-2 py-0.5 rounded-md text-[12px] ${regime === 'Leverage build' ? 'bg-emerald-500/15 text-emerald-300' : regime === 'De-leveraging' ? 'bg-rose-500/15 text-rose-300' : 'bg-slate-600/20 text-slate-300'}`}>{regime}</span>
      </div>
      <div className="grid grid-cols-2 gap-2">
        <MetricBox label="FR Positive (OI‑w)" value={pOiw} fmt="pct1" />
        <MetricBox label="FR Positive (Vol‑w)" value={pVolw} fmt="pct1" />
      </div>
    </DataCard>
  );
};

export default RegimeCard;
